import { Injectable } from '@angular/core';

import { EntityStore, StoreConfig } from '@datorama/akita';

import { PricePlansState } from './price-plans.state';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'pricePlans', resettable: true, idKey: 'plan_code' })
export class PricePlansStore extends EntityStore<PricePlansState> {
  constructor() {
    super();
  }
}
